import { WISESHEETS_API_URL } from '../constants'

const axios = require('axios').default

export const httpClient = axios.create({
    baseURL: WISESHEETS_API_URL,
    timeout: 60000,
})

// Add a request interceptor
httpClient.interceptors.request.use(
    async (config) => {
        // Add auth token to header of each request if available
        const token = window.localStorage.getItem('token')
        const fmpApiKey = window.localStorage.getItem('fmpApiKey')
        if (config.headers !== undefined) {
            if (token !== null) {
                config.headers.Authorization = token
            }
            if (fmpApiKey !== null) {
                config.headers['x-api-key'] = fmpApiKey
            }
        }
        return config
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error)
    }
)
